import React from 'react';
import ModalLayout from '../ModalLayout';
import styles from './UnavailableDishes.scss';
import BasicModalLayoutFooter from '../ModalLayout/BasicModalLayoutFooter';
import { OrderItem } from '../OrderPrintout/OrderPrintout';
import { CurrencyUtils } from '@wix/wixrest-utils';
import { Modals } from '../../utils/constants';

import { Modal, Text, Layout } from 'wix-style-react';

const UNAVAILABLE_DISHES_TITLE = 'Unavailable dishes';
const UNAVAILABLE_DISH_TITLE = 'Unavailable dish';
const UNAVAILABLE = ' (Unavailable)';
const UNAVAILABLE_VARIATION = ' (Unavailable Variation)';
const CANCEL_TEXT = 'Cancel';
const OK_TEXT = 'Continue';
const SUBTITLE_TEXT = 'The following dish is unavailable and won’t be added to cart:';

export default class UnavailableDishes extends React.Component {
  _handleOkClick = () => {
    this.props.onOkClick();
    this.props.hideModal({ modal: Modals.UNAVAILABLE_DISHES });
  };

  _handleCancelClick = () => {
    this.props.onCancelClick();
    this.props.hideModal({ modal: Modals.UNAVAILABLE_DISHES });
  };

  render() {
    const { dishes = [], isOpen = false, currency, locale } = this.props;
    const title = <div>{dishes.length > 1 ? UNAVAILABLE_DISHES_TITLE : UNAVAILABLE_DISH_TITLE}</div>;
    const footer = (
      <BasicModalLayoutFooter
        onOkClick={this._handleOkClick}
        onCancelClick={this._handleCancelClick}
        okText={OK_TEXT}
        cancelText={CANCEL_TEXT}
      />
    );

    const Subtitle = () => (
      <Text size="medium" weight="normal" tagName="div" className={styles.subtitle}>
        {SUBTITLE_TEXT}
      </Text>
    );
    return (
      <Modal onRequestClose={this._handleCancelClick} isOpen={isOpen}>
        <ModalLayout onCloseClick={this._handleCancelClick} title={title} footer={footer} size="medium">
          <div data-hook="order-history-unavailable-dishes">
            <Subtitle />
            <Layout gap="6px">
              {dishes.map((dish, index) => (
                <OrderItem
                  key={index}
                  title={
                    <React.Fragment>
                      {dish.item.title}
                      {dish.unavailableVariations.length > 0 ? UNAVAILABLE_VARIATION : UNAVAILABLE}
                    </React.Fragment>
                  }
                  count={dish.item.count}
                  price={CurrencyUtils.toStr(dish.item.price / 100, currency, locale)}
                  index={index}
                  variations={dish.variations}
                />
              ))}
            </Layout>
          </div>
        </ModalLayout>
      </Modal>
    );
  }
}
